import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-router-dom";
import Function from "../../../StateContext/Application";
const CreateEmployee = () => {
  const types = useContext(Function);
  const { EmployeeManagement, Roles, DepartmentHandler } = types;

  const [formData, setFormData] = useState({
    FullName: "",
    ProfilePic: "",
    PhoneNumber: "",
    Email: "",
    Password: "",
    RoleID: "",
    Role: "",
    Department_ID: "",
    Department_Name: "",
  });

  const [Role, SetRole] = useState([]);
  const [optionrole, SelectedRole] = useState();
  const [DepartmentList, SetDepartment] = useState([]);
  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    try {
      let data = await Roles("View", null);
      SetRole(data);
      let department = await DepartmentHandler("view", null, null);
      SetDepartment(department);
    } catch (error) {
      console.error(error);
    }
  };
  const handleChange = async (e) => {
    try {
      if (e.target.id === 'Department_Name') {
        let obj = JSON.parse(e.target.value);
        SelectedRole(obj.Department_ID);
        formData.Department_Name = obj.Department_Name;
        formData.Department_ID = obj.Department_ID;
      } else if (e.target.id === 'Role') {
        let obj = JSON.parse(e.target.value);
        formData.Role = obj.Designation;
        formData.RoleID = obj.RoleID;
      } else {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      }
    } catch (error) {
      console.error(error);
    }
  };
  const Submit = async () => {
    try {
      let data = await EmployeeManagement('Create', formData);
      if (data) {
        alert("Employee Created Successfully")
      } else {
        alert("Employee Not Created")
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{ display: "grid", justifyContent: "center" }}>
      <h5>Create Employee</h5>
      <div className="card m-5" style={{ width: "400px" }}>
        <div className="card-body">
          <Form onSubmit={Submit}>
            <div className="mb-3">
              <label className="form-label">Full Name</label>
              <input
                type="text"
                className="form-control"
                name="FullName"
                value={formData.FullName}
                onChange={handleChange}
                required
                placeholder="Enter Full Name Here"
              />
            </div>
            <div className="mb-3">
              <label className="form-label" hidden>
                Profile Picture
              </label>
              <input
                type="text"
                className="form-control"
                name="ProfilePic"
                value={formData.ProfilePic}
                onChange={handleChange}
                hidden
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Phone Number</label>
              <input
                type="tel"
                pattern="\d{10}"
                minLength="10"
                maxLength="10"
                className="form-control"
                name="PhoneNumber"
                value={formData.PhoneNumber}
                onChange={handleChange}
                onInput={(e) => {
                  let enteredValue = e.target.value;
                  enteredValue = enteredValue.slice(0, 10).replace(/\D/g, "");
                  e.target.value = enteredValue;
                }}
                placeholder="Enter Phone Number Here"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                name="Email"
                value={formData.Email}
                onChange={handleChange}
                placeholder="Enter Email Here"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                name="Password"
                value={formData.Password}
                onChange={handleChange}
                placeholder="Enter Password Here"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Select Department</label>

              <select
                className="form-control"
                id="Department_Name"
                onChange={(e) => handleChange(e)}
              >
                <option value={false}>Select Department</option>
                {DepartmentList.map((e) => {
                  return (
                    <option key={e.Department_ID} value={JSON.stringify(e)}>
                      {e.Department_Name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Role</label>

              <select
                className="form-control"
                id="Role"
                onChange={(e) => handleChange(e)}
              >
                <option value={false}>Selected Role</option>
                {Role.map((e) => {
                  if (optionrole === e.Department_ID) {
                    return (
                      <option key={e.RoleID} value={JSON.stringify(e)}>
                        {e.Designation}
                      </option>
                    );
                  }
                })}
              </select>
            </div>

            <div style={{ display: "grid", justifyContent: "center" }}>
              <button
                type="submit"
                className="btn btn-primary"
                style={{ backgroundColor: "#e73d26", border: "none" }}
              >
                Submit
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CreateEmployee;
